(function () {
    'use strict';

    angular
        .module('memories')
        .directive('xxOutingView', xxOutingView);

    function xxOutingView() {
        var result,
            themeClasses;

        result = {
            restrict: 'E',
            templateUrl: 'app/memories/outing-view.html',
            scope: { outing: '=' },
            bindToController: true,
            controllerAs: 'vm',
            controller: OutingViewCtrl
        };

        OutingViewCtrl.$inject = ['$filter', '$location', '$uibModal', 'Outing', 'Memory', app.modules.common.constants.appsettings, app.modules.common.constants.themelist, app.modules.common.services.functions, "ngDialog"];
        function OutingViewCtrl($filter, $location, $uibModal, Outing, Memory, ggAppSettings, ggThemes, ggFunctions, ngDialog) {
            var vm = this,
                dateFilter = $filter('date'),
                themes = themeClasses || (themeClasses = createThemeMap());

            vm.themeClass = themes[vm.outing.themeId];
            vm.displayDates = displayDates;
            vm.openLeaderboardWindow = openLeaderboardWindow;   
            vm.openMemoriesModal = openMemoriesModal;

            function displayDates(outing) {
                var startOn = removeTime(outing.startOn),
                    endOn = removeTime(outing.endOn) || startOn;

                return startOn && dateFilter(startOn) + (startOn - endOn ? " - " + dateFilter(endOn) : '') || '';
            }

            function removeTime(date) {
                return date && date.setHours(0, 0, 0, 0) && date || date;
            }

            function openLeaderboardWindow() {
                var leaderboardWnd,
                    url = app.Branding.http + app.Branding.rootURL + '#/outing/lb?tk={0}';

                leaderboardWnd = window.open();
                Outing.getOutingToken({ id: vm.outing.id }, success, error);

                function success(response) {
                    leaderboardWnd.location = url.format(response.publicAccessToken);
                }
                function error(response) {
                    leaderboardWnd.close();
                    alert('Failed to generate leaderboard url');
                }
            }

            function createThemeMap() {
                return ggThemes.reduce(reduce, {});

                function reduce(prev, curr) {
                    return (prev[curr.themeId] = curr.className) && prev || prev;
                }
            }

           
            function openMemoriesModal() {
                var outingId = vm.outing.id,
                    memoryWnd;
               
                
                var tu = "app/memories/memories-modal.html";
                app.Member.Session.pageTemplates.fetch(tu).then(function (template) {
                    if (isCordova && isCordovaReady) {
                        StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                    }

                    var _memoryModal = ngDialog.open({
                        template: template
                       , plain: true
                       , closeByEscape: true
                       , closeByDocument: true
                       , className: "slideup detail memory"
                       , trapFocus: false
                        , controller: "MemoriesModalCtrl"
                        , controllerAs: 'vm'
                        , resolve: { outingId: function () { return outingId; }, memories: memoriesResolver, refresh: refresh }
                    });
                    _memoryModal.closePromise.then(function () {
                        if (isCordova && isCordovaReady) {
                            StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                        }
                    });
                });




                
                function memoriesResolver() {
                    //ggFunctions.toggleProcessing(true);
                    return Memory.queryByOuting({ outingId: outingId }).$promise;
                }

                function refresh() { return memoriesResolver; }
            }
        }

        return result;
    }
})();